import React, { useState } from 'react';
import styles from './EmailRegistrationModal.module.css';
import { useAppConfig } from '../../context/AppConfigContext';

const EmailAuthModal = ({ onClose, onSendMagicLink }) => {
  const { t } = useAppConfig();

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const [info, setInfo] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = () => {
    setEmailError('');
    const e = (email || '').trim();

    if (!e) {
      setEmailError(t.registr?.email_required || 'Email обязателен');
      return null;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(e)) {
      setEmailError(t.registr?.invalid_email || 'Некорректный email');
      return null;
    }
    return e;
  };

	const handleSend = async () => {
	  setInfo('');
	  setError('');

	  const e = validateEmail();
	  if (!e) return;

	  try {
		setIsLoading(true);
		await onSendMagicLink(e);

		setInfo(
		  t.registr?.magic_link_sent ||
			'Ссылка для входа отправлена. Проверьте email и папку SPAM.'
		);
	  } catch (err) {
		setError(t.registr?.magic_link_error || 'Не удалось отправить ссылку');
	  } finally {
		setIsLoading(false);
	  }
	};


  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3 style={{ marginTop: 0 }}>
          {t.registr?.login || 'Вход'}
        </h3>

        <input
          type="email"
          placeholder={t.registr?.email_placeholder || 'Email'}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={emailError ? styles.errorInput : ''}
        />
        {emailError && <div className={styles.errorMessage}>{emailError}</div>}

        <div className={styles.buttons}>
			<button
			  className={styles.startButton}
			  onClick={info ? onClose : handleSend}
			  disabled={isLoading}
			>
			  {isLoading
				? (t.registr?.sending || 'Отправляем...')
				: info
				  ? (t.registr?.ok || 'Ок')
				  : (t.registr?.send_magic_link || 'Отправить ссылку')}
			</button>


          <button className={styles.startButton} onClick={onClose} disabled={isLoading}>
            {t.registr?.cancel || 'Отмена'}
          </button>
        </div>

        {info && <div className={styles.infoMessage}>{info}</div>}
        {error && <div className={styles.errorMessage}>{error}</div>}
      </div>
    </div>
  );
};

export default EmailAuthModal;